import type { ItemDisplayColumn } from '@/api/hanly-v2/hanlyAPIV2.schemas';
import { buildPackagings, formatPackagingBreakdown } from './packaging';
import type { OrderItemDisplayData } from './types';

const isColumnVisible = (columns: readonly ItemDisplayColumn[] | undefined, key: string): boolean => {
  if (!columns) return true;
  const col = columns.find((c) => c.key === key);
  return col ? col.visible : true;
};

export interface ItemColumnVisibility {
  productCode: boolean;
  modelNumber: boolean;
  spec: boolean;
  manufacturer: boolean;
  snp: boolean;
  deliveryDate: boolean;
}

/** 明細の表示設定(item_display_columns)から、明細で出す項目を決める */
export const toItemColumnVisibility = (
  columns: readonly ItemDisplayColumn[] | undefined,
): ItemColumnVisibility => ({
  productCode: isColumnVisible(columns, 'product_code'),
  modelNumber: isColumnVisible(columns, 'model_number'),
  spec: isColumnVisible(columns, 'spec'),
  manufacturer: isColumnVisible(columns, 'manufacturer'),
  snp: isColumnVisible(columns, 'snp'),
  deliveryDate: isColumnVisible(columns, 'delivery_date'),
});

/** 商品名の下に添える「商品コード ・ 品番 ・ 規格 ・ メーカー」 */
export const formatItemMeta = (item: OrderItemDisplayData, visibility: ItemColumnVisibility): string =>
  [
    visibility.productCode && item.productCode,
    visibility.modelNumber && item.modelNumber,
    visibility.spec && item.spec,
    visibility.manufacturer && item.manufacturer,
  ]
    .filter(Boolean)
    .join(' ・ ');

/** 数量(バラ総数)の荷姿換算内訳。荷姿が無い・数量0以下なら null */
export const formatItemBreakdown = (item: OrderItemDisplayData): string | null =>
  formatPackagingBreakdown(item.quantity, buildPackagings(item.packagingTypeName, item.snp), item.unitLabel);

/** 「+1ケース」で増やせる荷姿。荷姿が無ければ null */
export const getPrimaryPackaging = (item: OrderItemDisplayData) =>
  buildPackagings(item.packagingTypeName, item.snp)[0] ?? null;

export const formatYen = (value: string | number) => Number(value).toLocaleString();
